export default __webpack_public_path__ + "static/sidebar2-3c70d8f50237217c05fd6ea16a9b57b3.png";